import Axios from "../utils/union-axios";
import request from "./request";

// 充电站接口：https://portal.test.logan.xiaopeng.local/#/docs/detail?name=xp-charge-boot&url=%2Fdoc%2Fservices%2Fxp-charge-boot%2Fdoc&hash=resources-power-pack-controller-test-applicable-stations&focusmode=1&guestlogin=1
export interface StationPack {
  stationId: number;
  lat: number;
  lng: number;
  selfRun: boolean;
  stationCooperationType: number;
  // 是否上下架：0 下架，1上架 ，2待上架【暂时未用到】
  openFlag: string;
}

export interface StationsPackData {
  // 是否全国通用
  isAll: boolean;
  // 是否权益站
  isRightPack: boolean;
  stations: StationPack[];
}

// 根据电量包id获取站点
export function getStationsByPackId(custPqListId: string) {
  return request<{ custPqListId: string }, StationsPackData>(
    "/v5/charge/power/pack/applicableStations",
    {
      custPqListId
    },
    "POST"
  );
}

export enum StationStatusEnum {
  ON = "1",
  OFF = "0",
  WAIT = "2"
}
// 获取充电站详情
export interface StationDto {
  // 0非自营 1自营
  selfSupportFlag: string;
  stationId: string;
  stationName: string;
  stationAddr: string;
  //0正常 1加盟 2合作
  stationCooperationType: number;
  distance: string;
  // 充电费单价
  chargeAmt: string;
  // 服务费单价
  serviceAmt: string;
  payment: string;
  // 快充数量
  dcNums: number;
  dcFreeNums: number;
  // 慢充数量
  acNums: number;
  acFreeNums: number;
  openFlag: StationStatusEnum;
  // 专享
  allXpPile: boolean;
  // 免费
  freeStation: boolean;
  operationMode: number; // 自营站场站类型判断条件调整 1: 自营, 2: 加盟, 3: 合作, 0: 普通（其他）

  // 新增专享
  showXpOwner: boolean;
  // 新增免费
  showFree: boolean;
  // 气泡样式枚举，buildingXp-灰色小鹏logo气泡，xp-小鹏logo的气泡，lighting-闪电
  bubbleIconType: "buildingXp" | "xp" | "lighting";
  // 超快充数量
  s4Nums: number;
  // 超快充空闲数量
  s4FreeNums: number;
}

export function queryStationById(stationId: string) {
  return request<{ stationId: string }, StationDto>(
    "/v5/charge/queryStationDtl",
    {
      stationId
    },
    "POST"
  );
}

// 附近充电站列表
export interface StationInfoNear {
  id: string;
  name: string;
  areaCode: number;
  lat: number;
  lng: number;
  provider: string;
  connectors: number;
  selfRun: boolean;
  // 01建设中 02 运营 03停运 04检修
  stationStatus: string;
  stationStatusName: string;
  xpPileNum: number;
  // 0:正常 1：加盟 2： 合作
  stationCooperationType: number;
  // 是否上下架：0 下架，1上架 ，2待上架【暂时未用到】
  openFlag: string;
}
export interface StationsNearData {
  needUpdate: boolean;
  // 城市编码
  city: number;
  version: number;
  list: StationInfoNear[];
}
// 还有其他参数
export function getStationsNear(data: any) {
  return request<any, StationsNearData>(
    "/v5/charge/queryStationPosition",
    data,
    "POST"
  );
}

export interface FreeXpStationItem {
  stationId: number;
  stationName: string;
  lon: number;
  lat: number;
  freeStation: boolean;
  allXpPile: boolean;
  openFlag: string;

  bubbleIconType: "lighting" | "buildingXp" | "xp";
  showFree: boolean;
  showXpOwner: boolean;
  operationMode: number;
  selfSupportFlag: string;
  s4Nums: number;
  dcNums: number;
}

// export interface newFreeXpStationItem {
//   stationId: number;
//   stationName: string;
//   lon: number;
//   lat: number;
//   freeStation: boolean;
//   allXpPile: boolean;
//   openFlag: string;
//   distance: number;
//   newStation: boolean;
// }

export interface FreeXpStationDto {
  records: FreeXpStationItem[];
}
// 免费专享站
export function freeXpStations(data: any) {
  return request<any, FreeXpStationDto>(
    "/v5/charge/free/order/map",
    data,
    "GET"
  );
}

// 充电失败场景化-失败原因与信息
export function getChargeFailGuide(messageId: string) {
  return request<{ messageId: string }, any>(
    "/v5/charge/guide/plugChargeFailGuide",
    {
      messageId
    },
    "POST"
  );
}
export interface StationReq {
  areaCode: string;
  cityCode: string;
  lon: number;
  lat: number;
  radius: number;
}

export interface NearByStationReq {
  lon: number;
  lat: number;
  radius: number;
  operatorType: number;
}

// 附近充电站数量统计
export function getNearbyStationNum(data: StationReq): Promise<any> {
  return request<StationReq, any>(
    "/v5/charge/home/page/getNearbyStationNum",
    data,
    "POST"
  );
}

// 附近充电站
export function findNearByStation(data: NearByStationReq): Promise<any> {
  return request<NearByStationReq, any>(
    "/v5/charge/home/page/findNearByStation",
    data,
    "POST"
  );
}

/**
 * 通过活动编码查询适用站点列表
 * @param data
 * @returns
 */
export function findNearByStationV2(data) {
  return Axios.post(`/web-h5/charge/station/search/findNearByStationV2`, data);
}
